
if (!window.obelix) {
    throw "☠ obelix configuration missing";
}
if (!window.obelix.htmlSelector) {
    throw "☠ obelix.htmlSelector missing";
}

import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue';
import VueLogger from 'vuejs-logger';

const options = {
    isEnabled: true,
    logLevel: process.env.NODE_ENV === 'production' ? 'error' : 'info',
    stringifyArguments: false,
    showLogLevel: true,
    showMethodName: true,
    separator: '|',
    showConsoleColors: true
};
Vue.use(VueLogger, options);

import VueCompositionApi from '@vue/composition-api';
Vue.use(VueCompositionApi);

import './plugins/bootstrap-vue'
import './plugins/vue-select'
import './plugins/translation'
import App from './App.vue';
import store from './store';
import router from './router'

import './config/fontawesome';

Vue.config.productionTip = false;
Vue.prototype.isFeatureEnabled = window.isFeatureEnabled;
new Vue({
    router,
    render: h => h(App),
    store,
    beforeMount: function () {
        const params = window.obelix;

        store.dispatch('setArticle', { product: params.productPsid, thickness: params.thicknessPsid });
        store.dispatch('setCustomerPsid', params.customerPsid);
        store.dispatch('setCartPsid', params.cartPsid);
        store.dispatch('setLanguage', params.language || 'fr');
        store.dispatch('setBabelMode', params.babelMode);
        if (params.standalone) store.dispatch('setStandaloneMode', true);
        if (params.compositionId) {
            store.dispatch('setCompositionId', params.compositionId);
        } else {
            if (router.history && router.history.pending) {
                let routerCompositionId = router.history.pending.params.compositionId;
                if (routerCompositionId) {
                    store.dispatch('setCompositionId', routerCompositionId);
                    router.push({ name: 'editor'});
                } else {
                    store.dispatch('setCompositionId', null);
                }
            } else {
                store.dispatch('setCompositionId', null);
            }
        }
    }
}).$mount(window.obelix.htmlSelector);

